import { curveBasis, line } from 'd3-shape';
import { useMemo } from 'react';

interface TrendLineProps {
  bars: any;
  yScale: any;
  data: any;
}

export function TrendLine({ bars, yScale, data }: TrendLineProps) {
  const points = bars.map((bar: any) => {
    const x = bar.x + bar.width / 2;
    const trend = data.find((d: any) => d.key === bar.data.indexValue)?.trend ?? 0;
    const y = yScale(trend);
    return [x, y];
  });

  const hasYValue = useMemo(() => {
    return bars.reduce((acc: boolean, bar: any) => {
      const trend = data.find((d: any) => d.key === bar.data.indexValue)?.trend ?? 0;
      return acc || trend !== 0;
    }, false);
  }, [bars]);

  if (!hasYValue) return null;

  const pathGenerator = line()
    .x((d) => d[0])
    .y((d) => d[1])
    .curve(curveBasis);
  const pathData = pathGenerator(points);
  if (!pathData) return null;
  return <path d={pathData} fill="none" stroke="#FACC15" strokeWidth={2} />;
}
